var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 16,
    viewBox: "0 0 31 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8839 8.70711C30.2744 8.31658 30.2744 7.68342 29.8839 7.29289L23.5199 0.928932C23.1294 0.538408 22.4962 0.538408 22.1057 0.928932C21.7152 1.31946 21.7152 1.95262 22.1057 2.34315L27.7625 8L22.1057 13.6569C21.7152 14.0474 21.7152 14.6805 22.1057 15.0711C22.4962 15.4616 23.1294 15.4616 23.5199 15.0711L29.8839 8.70711ZM0.0268555 9H29.1768V7H0.0268555V9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRight);
export default __webpack_public_path__ + "static/media/ic_arrow_right.0e0c923c19ea828a3460facc54b8b30d.svg";
export { ForwardRef as ReactComponent };